// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3o2gA","options":"AnswerScale_options__3RuxS","selected":"AnswerScale_selected__3G_nN"};